import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 0,

  title: 'Equipment',
  description: 'Equipment used in any blood donation action',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    name: types.STRING_INDEX,
    serialNumber: types.STRING_INDEX,
    manufacturerDate: types.DATE_INDEX,
    expiryDate: types.DATE,

    maintenanceSchedule: types.STRING,
    isFunctional: types.BOOLEAN,

    facility: types.OBJECT,
    item: types.OBJECT,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'serialNumber'],
  indexes: [
    ['name'],
    ['serialNumber']
  ],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
